// extracted by mini-css-extract-plugin
module.exports = {"root":"chip_root__rwP_Y","icon":"chip_icon__ncd6E"};